import React, { useState } from "react";
import Welcome from "../pages/Welcome";

const VestibuleGate = ({ children }) => {
  const [open, setOpen] = useState(() => {
    try {
      return localStorage.getItem("steck_visitor_acknowledged") !== "1";
    } catch {
      return true;
    }
  });

  const dismiss = () => setOpen(false);

  return (
    <>
      {children}
      {open && <Welcome onDismiss={dismiss} />}
    </>
  );
};

export default VestibuleGate;
